module.exports = __webpack_public_path__ + "news_03.png?43726155d44d6c8d5d052fdea9fa2ea3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lottery/news_03.png
// module id = 635
// module chunks = 0